import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TagInterface } from '../interfaces/tag.interface';
import { Tag } from '../models/tag.model';
import { map } from 'rxjs/operators';
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class TagsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get all tags.
   *
   * @param projectId ProjectId.
   * @returns Tags.
   */
  public getAllTags(projectId: number): Observable<Tag[]> {
    this.path = `/v1/bimdata/projects/${projectId}/tag`;
    return this.get<Tag[]>().pipe(
      map((tags: Tag[]) => {
        return tags.map((tag: Tag) => new Tag(tag)).sort((a: Tag, b: Tag) => a.isCurrentNameBeforeTagName(b));
      })
    );
  }

  /**
   * Create a tag.
   *
   * @param projectId ProjectId.
   * @param newTag New tag.
   * @returns Observable<Tag>.
   */
  public createTag(projectId: number, newTag: TagInterface): Observable<Tag> {
    this.path = `/v1/bimdata/admin/projects/${projectId}/tag`;
    return this.post({ body: newTag });
  }

  /**
   * Delete a tag.
   *
   * @param projectId ProjectId.
   * @param tagId TagId.
   * @returns Observable<boolean>
   */
  public deleteTag(projectId: number, tagId: number): Observable<void> {
    this.path = `/v1/bimdata/admin/projects/${projectId}/tag/${tagId}`;
    return this.delete<void>();
  }

  /**
   * Update Tag.
   *
   * @param projectId ProjectId.
   * @param tagId TagId.
   * @param updatedTag updatedTag.
   * @returns Observable<boolean>.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateTag(projectId: number, tagId: number, updatedTag: TagInterface): Observable<Tag> {
    this.path = `/v1/bimdata/admin/projects/${projectId}/tag/${tagId}`;
    return this.patch({ body: updatedTag });
  }

  /**
   * Create Tag instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `Tag` instance.
   */
  public createNewInstance(jsonObject: TagInterface): Tag {
    return new Tag(jsonObject);
  }
}
